export var LDEventType;
(function (LDEventType) {
    LDEventType["Update"] = "update";
})(LDEventType || (LDEventType = {}));
